// Client-side logger with different log levels
const LOG_LEVELS = {
  ERROR: 0,
  WARN: 1,
  INFO: 2,
  DEBUG: 3,
};

const currentLogLevel = process.env.NODE_ENV === 'production' 
  ? LOG_LEVELS.ERROR 
  : LOG_LEVELS.DEBUG;

// Production-safe logger
class Logger {
  constructor(context = 'App') {
    this.context = context;
  }

  error(message, error = null) {
    if (currentLogLevel >= LOG_LEVELS.ERROR) {
      console.error(`[${this.context}] ${message}`, error);
      
      // Send to Sentry in production
      if (process.env.NODE_ENV === 'production' && window.Sentry) {
        window.Sentry.captureException(error || new Error(message), {
          tags: { context: this.context },
        });
      }
    }
  }

  warn(message, data = null) {
    if (currentLogLevel >= LOG_LEVELS.WARN) {
      console.warn(`[${this.context}] ${message}`, data);
    }
  }

  info(message, data = null) {
    if (currentLogLevel >= LOG_LEVELS.INFO) {
      console.info(`[${this.context}] ${message}`, data);
    }
  }

  debug(message, data = null) {
    if (currentLogLevel >= LOG_LEVELS.DEBUG) {
      console.log(`[${this.context}] ${message}`, data);
    }
  }

  // Performance logging
  time(label) {
    if (currentLogLevel >= LOG_LEVELS.DEBUG) {
      console.time(`[${this.context}] ${label}`);
    }
  }

  timeEnd(label) {
    if (currentLogLevel >= LOG_LEVELS.DEBUG) {
      console.timeEnd(`[${this.context}] ${label}`);
    }
  }

  // Track user actions for analytics
  trackEvent(action, category = this.context, label = null, value = null) {
    if (window.gtag && process.env.REACT_APP_GA_TRACKING_ID) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    }
  }
}

// Create loggers for different modules
export const createLogger = (context) => new Logger(context);

// Default logger instance
const defaultLogger = new Logger();

export default defaultLogger;